import React, { useState, useEffect } from 'react';
import { Menu, X, Github, Linkedin, Twitter, Mail, ExternalLink, Facebook } from 'lucide-react';
import { FiPhone } from "react-icons/fi";

const Portfolio = () => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [activeSection, setActiveSection] = useState('home');
  const [formStatus, setFormStatus] = useState({ show: false, message: '', type: '' });
  const handleSubmit = async (e) => {
    e.preventDefault();

    const form = e.target;
    const formData = new FormData(form);

    try {
      const response = await fetch('https://formsubmit.co/karunarathnedumindu@gmail.com', {
        method: 'POST',
        body: formData,
        headers: {
          'Accept': 'application/json'
        }
      });

      if (response.ok) {
        setFormStatus({
          show: true,
          message: 'Message sent successfully! I\'ll get back to you soon.',
          type: 'success'
        });
        form.reset();

        setTimeout(() => {
          setFormStatus({ show: false, message: '', type: '' });
        }, 5000);
      } else {
        throw new Error('Failed to send message');
      }
    } catch (error) {
      setFormStatus({
        show: true,
        message: 'Failed to send message. Please try again or email me directly.',
        type: 'error'
      });

      setTimeout(() => {
        setFormStatus({ show: false, message: '', type: '' });
      }, 5000);
    }
  };
  // Smooth scroll to section
  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
      setMobileMenuOpen(false);
    }
  };

  // Track active section on scroll
  useEffect(() => {
    const handleScroll = () => {
      const sections = ['home', 'works', 'about-me', 'contacts'];
      const scrollPosition = window.scrollY + 100;

      for (const section of sections) {
        const element = document.getElementById(section);
        if (element) {
          const { offsetTop, offsetHeight } = element;
          if (scrollPosition >= offsetTop && scrollPosition < offsetTop + offsetHeight) {
            setActiveSection(section);
            break;
          }
        }
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const projects = [
    {
      title: '404 Travels',
      description: 'Next.js travel agency website for 404 Travels with tours, bookings, and visa assistance.',
      image: '/404travels.png',
      tech: 'TypeScript',
      liveLink: 'https://404travels.com',
      cached: false
    },
    {
      title: 'Apollo Guidance Computer Exhibit',
      description: 'Apollo Guidance Computer simulation with DSKY hardware prototype using Arduino, C++, and Python',
      image: '/agc.jpg',
      tech: 'Arduino C++ Python',
      liveLink: 'https://github.com/thisum-dev/apollo-guidance-computer-EngEx',
      cached: false
    },
    
    {
      title: 'eSkole User Site',
      description: 'Educational platform built for students affected by floods, providing learning materials and resources.',
      image: '/eskole-user.png',
      tech: 'Next.js CSS Node.js MongoDB',
      liveLink: 'https://eskole.vercel.app',
      cached: false
    },
    {
      title: 'eSkole Admin Site',
      description: 'Administration dashboard for managing content, students, and resources for the eSkole educational platform.',
      image: '/eskole-admin.png',
      tech: 'Next.js CSS Node.js MongoDB',
      liveLink: 'https://admin-eskole.vercel.app',
      cached: false
    },
    {
      title: 'Hikka Rent Mobile App',
      description: 'A React Native app for Hikka Rent, enabling users to browse, book, and manage accommodation rentals seamlessly.',
      image: '/hikka-rent.jpg',
      tech: 'React Native JavaScript Expo',
      liveLink: 'https://github.com/duminduk/hikka-rent',
      cached: false
    }
  ];

  const smallProjects = [
    { title: 'New Tech UI', description: 'Fully featured eCommerce frontend for a mobile & accessories store with clean UI and smooth cart flow.', tech: 'HTML CSS JS', link: 'https://github.com/duminduk/newtechui' },
    { title: 'Flappy Bird', description: 'A simple 2D game built using Pygame Zero with basic player movement and obstacle interaction', tech: 'Python PygameZero ', link: '' },
    { title: 'Neurobot', description: 'Autonomous robot that detects and avoids obstacles using computer vision in Webots', tech: 'Python Webots OpenCV', link: 'https://github.com/duminduk/NeuroBot' },
    { title: 'libtiny3d : 3D Software Renderer', description: 'A 3D graphics engine in C with custom math, rendering pipeline, lighting, and animations.', tech: 'C Math', link: 'https://github.com/duminduk/libtiny3d' }
    
  ];

  const skills = {
    languages: ['TypeScript', 'Python', 'JavaScript'],
    databases: ['MySQL', 'PostgreSQL', 'MongoDB'],
    tools: ['VSCode', 'Antigravity', 'Linux', 'Git'],
    other: ['HTML', 'CSS'],
    frameworks: ['React', 'Next.js', 'Node.js', 'React Native', 'Tailwind CSS']
  };



  return (
    <div className="bg-[#282C33] text-white min-h-screen font-mono">
      {/* Decorative dots pattern */}
      <div className="fixed top-20 left-8 opacity-30 hidden lg:block">
        <div className="grid grid-cols-5 gap-2">
          {[...Array(25)].map((_, i) => (
            <div key={i} className="w-1 h-1 bg-gray-500 rounded-full"></div>
          ))}
        </div>
      </div>

      {/* Header */}
      <header className="fixed top-0 left-0 right-0 bg-[#282C33] z-50 border-b border-gray-700">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-between items-center py-4">
            <div className="flex items-center gap-2">
              <div className="w-4 h-4">
                <img src="/favicon.png" alt="" />
              </div>
              <span className="font-bold">Dumindu K</span>
            </div>

            {/* Desktop Navigation */}
            <nav className="hidden md:flex items-center gap-8">
              <a
                href="#home"
                onClick={(e) => { e.preventDefault(); scrollToSection('home'); }}
                className={`${activeSection === 'home' ? 'text-[#C778DD]' : 'hover:text-[#C778DD]'} transition-colors`}
              >
                <span className="text-[#C778DD]">#</span>home
              </a>
              <a
                href="#works"
                onClick={(e) => { e.preventDefault(); scrollToSection('works'); }}
                className={`${activeSection === 'works' ? 'text-[#C778DD]' : 'hover:text-[#C778DD]'} transition-colors`}
              >
                <span className="text-[#C778DD]">#</span>works
              </a>
              <a
                href="#about-me"
                onClick={(e) => { e.preventDefault(); scrollToSection('about-me'); }}
                className={`${activeSection === 'about-me' ? 'text-[#C778DD]' : 'hover:text-[#C778DD]'} transition-colors`}
              >
                <span className="text-[#C778DD]">#</span>about-me
              </a>
              <a
                href="#contacts"
                onClick={(e) => { e.preventDefault(); scrollToSection('contacts'); }}
                className={`${activeSection === 'contacts' ? 'text-[#C778DD]' : 'hover:text-[#C778DD]'} transition-colors`}
              >
                <span className="text-[#C778DD]">#</span>contacts
              </a>
            
            </nav>

            {/* Mobile menu button */}
            <button
              className="md:hidden"
              onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
            >
              {mobileMenuOpen ? <X size={24} /> : <Menu size={24} />}
            </button>
          </div>

          {/* Mobile Navigation */}
          {mobileMenuOpen && (
            <nav className="md:hidden pb-4 space-y-4">
              <a
                href="#home"
                onClick={(e) => { e.preventDefault(); scrollToSection('home'); }}
                className="block hover:text-[#C778DD]"
              >
                <span className="text-[#C778DD]">#</span>home
              </a>
              <a
                href="#works"
                onClick={(e) => { e.preventDefault(); scrollToSection('works'); }}
                className="block hover:text-[#C778DD]"
              >
                <span className="text-[#C778DD]">#</span>works
              </a>
              <a
                href="#about-me"
                onClick={(e) => { e.preventDefault(); scrollToSection('about-me'); }}
                className="block hover:text-[#C778DD]"
              >
                <span className="text-[#C778DD]">#</span>about-me
              </a>
              <a
                href="#contacts"
                onClick={(e) => { e.preventDefault(); scrollToSection('contacts'); }}
                className="block hover:text-[#C778DD]"
              >
                <span className="text-[#C778DD]">#</span>contacts
              </a>
            </nav>
          )}
        </div>
      </header>

      {/* Side social links - Desktop only */}
      <div className="hidden lg:block fixed left-4 top-1/2 transform -translate-y-1/2 z-40">
        <div className="flex flex-col items-center gap-2">
          <div className="w-px h-32 bg-gray-600"></div>
          <a href="https://github.com/duminduk" target="_blank" rel="noopener noreferrer" className="hover:text-[#C778DD] transition-colors">
            <Github size={20} />
          </a>
          <a href="https://linkedin.com/in/dumindu-k" target="_blank" rel="noopener noreferrer" className="hover:text-[#C778DD] transition-colors">
            <Linkedin size={20} />
          </a>
          <a href="https://facebook.com/dumindu.karunarathne.2025" target="_blank" rel="noopener noreferrer" className="hover:text-[#C778DD] transition-colors">
            <Facebook size={20} />
          </a>
        </div>
      </div>

      <main className="pt-20">
        {/* Hero Section */}
        <section id="home" className="min-h-screen flex items-center">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-20">
            <div className="grid md:grid-cols-2 gap-12 items-center">
              <div>
                <h1 className="text-3xl sm:text-4xl lg:text-5xl font-bold mb-6">
                  Dumindu is a <span className="text-[#C778DD]">undergraduate</span> and{' '}
                  <span className="text-[#C778DD]">tech enthusiast</span>
                </h1>
                <p className="text-gray-400 mb-8">
                  He turns concepts into smart, functional, and impactful tech experiences.
                </p>
                <a href="#contacts">
                  <button className="border border-[#C778DD] text-white px-6 py-3 hover:bg-[#C778DD] hover:bg-opacity-10 transition-colors">
                    Contact me!!
                  </button>
                </a>
              </div>
              <div className="relative">
                <div className="absolute top-0 right-0 w-32 h-32 border-2 border-[#C778DD] opacity-20"></div>
                <img
                  src="/dumindu.png"
                  alt="Profile"
                  className="w-full max-w-md mx-auto rounded-lg"
                />
                <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 bg-[#282C33] border border-gray-600 px-4 py-2 flex items-center gap-2">
                  <div className="w-4 h-4 bg-[#C778DD]"></div>
                  <span className="text-sm">Currently working on <span className="font-bold">wedak.lk</span></span>
                </div>
              </div>
            </div>

            {/* Quote */}
            <div className="mt-20 border border-gray-600 p-8 max-w-2xl ml-auto relative">
              <div className="absolute -top-3 left-4 bg-[#282C33] px-2 text-2xl text-gray-600">"</div>
              <p className="text-center text-lg">Software is like sex: it's better when it's free</p>
              <div className="absolute -bottom-3 right-4 bg-[#282C33] px-2 text-2xl text-gray-600">"</div>
              <p className="text-right mt-4">- Linus Torvalds</p>
            </div>
          </div>
        </section>

        {/* Projects Section */}
        <section id="works" className="py-20">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="flex items-center justify-between mb-12">
              <h2 className="text-3xl font-bold">
                <span className="text-[#C778DD]">#</span>projects
              </h2>
              <a href="#" className="hover:text-[#C778DD]">View all ~~~&gt;</a>
            </div>

            {/* Complete Apps */}
            <h3 className="text-2xl font-bold mb-8">
              <span className="text-[#C778DD]">#</span>completed
            </h3>
            <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6 mb-16">
              {projects.map((project, index) => (
                <div key={index} className="border border-gray-600">
                  <img src={project.image} alt={project.title} className="w-full h-48 object-cover" />
                  <div className="p-4 border-t border-gray-600">
                    <p className="text-sm text-gray-400 mb-3">{project.tech}</p>
                    <h4 className="text-xl font-bold mb-2">{project.title}</h4>
                    <p className="text-gray-400 mb-4">{project.description}</p>
                    <div className="flex gap-4">
                      <a href={project.liveLink}
                        target="_blank"
                        rel="noopener noreferrer" className="border border-[#C778DD] px-4 py-2 hover:bg-[#C778DD] hover:bg-opacity-10 transition-colors inline-flex items-center gap-2">
                        Live &lt;~&gt;
                      </a>
                      {project.cached && (
                        <a href="#" className="border border-gray-600 px-4 py-2 hover:bg-gray-600 hover:bg-opacity-10 transition-colors inline-flex items-center gap-2">
                          Cached &gt;=
                        </a>
                      )}
                    </div>
                  </div>
                </div>
              ))}
            </div>

            {/* Small Projects */}
            <h3 className="text-2xl font-bold mb-8">
              <span className="text-[#C778DD]">#</span>small-projects
            </h3>
            <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
              {smallProjects.map((project, index) => (
                <div key={index} className="border border-gray-600 p-4">
                  <p className="text-sm text-gray-400 mb-3">{project.tech}</p>
                  <h4 className="text-xl font-bold mb-2">{project.title}</h4>
                  <p className="text-gray-400 mb-4">{project.description}</p>
                  <a href={project.link}
                    target="_blank"
                    rel="noopener noreferrer" className="border border-[#C778DD] px-4 py-2 inline-block hover:bg-[#C778DD] hover:bg-opacity-10 transition-colors">
                    {project.tech.includes('Figma') ? 'Figma' : 'Live'} &lt;~&gt;
                  </a>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* About Section */}
        <section id="about-me" className="py-20">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <h2 className="text-3xl font-bold mb-4">
              <span className="text-[#C778DD]">#</span>about-me
            </h2>
            <p className="text-gray-400 mb-12">Who am I?</p>

            <div className="grid md:grid-cols-2 gap-12 mb-16">
              <div>
                <p className="mb-4">Hello, I'm Dumindu!</p>
                <p className="mb-4 text-gray-400">
                  I'm a Computer Engineering undergraduate passionate about technology and problem-solving. I enjoy turning ideas into efficient and meaningful digital solutions.


                </p>
                <p className="text-gray-400">
                  Transforming my knowledge and curiosity into projects has been my focus for over a year. I have worked on personal and academic projects to build practical experience. I always strive to stay updated with the latest technologies and tools.</p>
                <button className="mt-6 border border-[#C778DD] px-6 py-3 hover:bg-[#C778DD] hover:bg-opacity-10 transition-colors">
                  Read more →
                </button>
              </div>
              <div className="relative flex items-center justify-center h-64">
                <style>
                  {`
      @keyframes orbit1 {
        from {
          transform: rotateZ(0deg) rotateY(75deg) rotateX(0deg);
        }
        to {
          transform: rotateZ(360deg) rotateY(75deg) rotateX(0deg);
        }
      }
      @keyframes orbit2 {
        from {
          transform: rotateZ(0deg) rotateY(75deg) rotateX(60deg);
        }
        to {
          transform: rotateZ(360deg) rotateY(75deg) rotateX(60deg);
        }
      }
      @keyframes orbit3 {
        from {
          transform: rotateZ(0deg) rotateY(75deg) rotateX(120deg);
        }
        to {
          transform: rotateZ(360deg) rotateY(75deg) rotateX(120deg);
        }
      }
      @keyframes orbit4 {
        from {
          transform: rotateZ(0deg) rotateY(75deg) rotateX(30deg);
        }
        to {
          transform: rotateZ(360deg) rotateY(75deg) rotateX(30deg);
        }
      }
      @keyframes orbit5 {
        from {
          transform: rotateZ(0deg) rotateY(75deg) rotateX(90deg);
        }
        to {
          transform: rotateZ(360deg) rotateY(75deg) rotateX(90deg);
        }
      }
      @keyframes rotateRings {
        from {
          transform: rotateY(0deg) rotateX(20deg);
        }
        to {
          transform: rotateY(360deg) rotateX(20deg);
        }
      }
      .atom-container {
        transform-style: preserve-3d;
        perspective: 1000px;
        animation: rotateRings 12s linear infinite;
      }
      .nucleus {
        position: absolute;
        width: 20px;
        height: 20px;
        background: #C778DD;
        border-radius: 50%;
        box-shadow: 0 0 20px #C778DD;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
      }
      .orbit {
        position: absolute;
        width: 200px;
        height: 200px;
        border: 2px solid rgba(199, 120, 221, 0.3);
        border-radius: 50%;
        top: 50%;
        left: 50%;
        margin-left: -100px;
        margin-top: -100px;
        transform-style: preserve-3d;
      }
      .orbit1 {
        animation: orbit1 6s linear infinite;
      }
      .orbit2 {
        animation: orbit2 6s linear infinite;
      }
      .orbit3 {
        animation: orbit3 6s linear infinite;
      }
      .orbit4 {
        animation: orbit4 5.5s linear infinite;
      }
      .orbit5 {
        animation: orbit5 6.5s linear infinite;
      }
      .electron {
        position: absolute;
        width: 12px;
        height: 12px;
        background: #C778DD;
        border-radius: 50%;
        box-shadow: 0 0 15px #C778DD;
        top: 0;
        left: 50%;
        transform: translateX(-50%);
      }
      .electron2 {
        top: 50%;
        left: 100%;
        transform: translate(-50%, -50%);
      }
      .electron3 {
        top: 100%;
        left: 50%;
        transform: translate(-50%, -50%);
      }
      .electron4 {
        top: 50%;
        left: 0;
        transform: translate(-50%, -50%);
      }
    `}
                </style>
                <div className="atom-container w-64 h-64 relative">
                  <div className="nucleus"></div>

                  <div className="orbit orbit1">
                    <div className="electron"></div>
                    <div className="electron electron3"></div>
                  </div>

                  <div className="orbit orbit2">
                    <div className="electron"></div>
                    <div className="electron electron3"></div>
                  </div>

                  <div className="orbit orbit3">
                    <div className="electron"></div>
                    <div className="electron electron2"></div>
                  </div>

                  <div className="orbit orbit4">
                    <div className="electron"></div>
                    <div className="electron electron2"></div>
                    <div className="electron electron3"></div>
                  </div>

                  <div className="orbit orbit5">
                    <div className="electron"></div>
                    <div className="electron electron2"></div>
                    <div className="electron electron3"></div>
                    <div className="electron electron4"></div>
                  </div>
                </div>
              </div>
            </div>

            {/* Skills */}
            <h3 className="text-2xl font-bold mb-8">
              <span className="text-[#C778DD]">#</span>skills
            </h3>
            <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-4 mb-16">
              <div className="border border-gray-600">
                <div className="border-b border-gray-600 p-2 font-bold">Languages</div>
                <div className="p-4 text-sm text-gray-400">{skills.languages.join(' ')}</div>
              </div>
              <div className="border border-gray-600">
                <div className="border-b border-gray-600 p-2 font-bold">Databases</div>
                <div className="p-4 text-sm text-gray-400">{skills.databases.join(' ')}</div>
              </div>
              <div className="border border-gray-600">
                <div className="border-b border-gray-600 p-2 font-bold">Tools</div>
                <div className="p-4 text-sm text-gray-400">{skills.tools.join(' ')}</div>
              </div>
              <div className="border border-gray-600">
                <div className="border-b border-gray-600 p-2 font-bold">Other</div>
                <div className="p-4 text-sm text-gray-400">{skills.other.join(' ')}</div>
              </div>
              <div className="border border-gray-600 sm:col-span-2 lg:col-span-4">
                <div className="border-b border-gray-600 p-2 font-bold">Frameworks</div>
                <div className="p-4 text-sm text-gray-400">{skills.frameworks.join(' ')}</div>
              </div>
            </div>
          </div>
        </section>

        {/* Contacts Section */}
        <section id="contacts" className="py-20">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <h2 className="text-3xl font-bold mb-4">
              <span className="text-[#C778DD]">#</span>contacts
            </h2>
            <p className="text-gray-400 mb-12">I'm interested in freelance opportunities. However, if you have other request or question, don't hesitate to contact me</p>

            {/* Notification */}
            {formStatus.show && (
              <div className="mb-6 p-4 border border-[#C778DD] bg-[#C778DD] bg-opacity-10 relative">
                <p className="text-[#C778DD]">
                  {formStatus.message}
                </p>
                <button
                  onClick={() => setFormStatus({ show: false, message: '', type: '' })}
                  className="absolute top-2 right-2 text-gray-400 hover:text-white"
                >
                  <X size={20} />
                </button>
              </div>
            )}

            <div className="grid md:grid-cols-3 gap-8">
              <div className="md:col-span-2 border border-gray-600 p-6">
                <h3 className="text-xl font-bold mb-6">
                  <span className="text-[#C778DD]">#</span>send-message
                </h3>
                <form onSubmit={handleSubmit}>
                  <input type="hidden" name="_subject" value="New message from Portfolio!" />
                  <input type="hidden" name="_captcha" value="false" />

                  <div className="grid md:grid-cols-2 gap-4 mb-4">
                    <div>
                      <label className="block mb-2 text-sm">Name</label>
                      <input
                        type="text"
                        name="name"
                        placeholder="Your name"
                        required
                        className="w-full bg-transparent border border-gray-600 px-4 py-2 focus:border-[#C778DD] focus:outline-none"
                      />
                    </div>

                    <div>
                      <label className="block mb-2 text-sm">Email</label>
                      <input
                        type="email"
                        name="email"
                        placeholder="your.email@example.com"
                        required
                        className="w-full bg-transparent border border-gray-600 px-4 py-2 focus:border-[#C778DD] focus:outline-none"
                      />
                    </div>
                  </div>

                  <div className="mb-4">
                    <label className="block mb-2 text-sm">Message</label>
                    <textarea
                      name="message"
                      placeholder="Your message..."
                      required
                      rows="4"
                      className="w-full bg-transparent border border-gray-600 px-4 py-2 focus:border-[#C778DD] focus:outline-none resize-none"
                    ></textarea>
                  </div>

                  <button
                    type="submit"
                    className="w-full border border-[#C778DD] px-6 py-3 hover:bg-[#C778DD] hover:bg-opacity-10 transition-colors"
                  >
                    Send Message
                  </button>
                </form>
              </div>

              <div className="space-y-4">
                <div className="border border-gray-600 p-4">
                  <p className="font-bold mb-2">Message me here</p>
                  <p className="text-sm text-gray-400 mb-2 flex items-center gap-2">
                    <FiPhone size={16} /> +94 72 028 1580
                  </p>
                  <p className="text-sm text-gray-400 flex items-center gap-2">
                    <Mail size={16} /> hi@duminduk.online
                  </p>
                </div>

                
              </div>
            </div>
          </div>
        </section>
      </main>

      {/* Footer */}
      <footer className="border-t border-gray-700 py-8">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <div>
              <div className="flex items-center gap-2 mb-2">
                <div className="w-4 h-4 ">
                  <img src="/favicon.png" alt="" />
                </div>
                <span className="font-bold">Dumindu K</span>
                <span className="text-sm text-gray-400 ml-4">hi@duminduk.online</span>
              </div>
              <p className="text-sm text-gray-400">Computer Engineering undergraduate</p>
            </div>
            <div>
              <p className="text-sm mb-2">Media</p>
              <div className="flex gap-4">
                <a href="https://github.com/duminduk" target='_blank' rel="noopener noreferrer" className="hover:text-[#C778DD]">
                  <Github size={20} />
                </a>
                <a href="https://facebook.com/dumindu.karunarathne.2025" target='_blank' rel="noopener noreferrer" className="hover:text-[#C778DD]">
                  <Facebook size={20} />
                </a>
                <a href="https://linkedin.com/in/dumindu-k" target='_blank' rel="noopener noreferrer" className="hover:text-[#C778DD]">
                  <Linkedin size={20} />
                </a>
              </div>
            </div>
          </div>
          <p className="text-center text-sm text-gray-400 mt-8">© Copyright 2025. Made by Dumindu K</p>
        </div>
      </footer>
    </div>
  );
};

export default Portfolio;
